<template>
<div>
  <Grid name="modalProdaggregsGrid" ref="modalProdaggregsGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
export default {
  name: 'Prodaggregs',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'prodaggregs',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectItem
        }
      }, {
        field: 'id',
        title: 'Id'
      }, {
        field: 'name',
        title: 'Name'
      }, {
        field: 'code',
        title: 'Código'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    selectItem(e) {
      e.preventDefault()
      var grid = this.$refs.modalProdaggregsGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      console.log('table selected item emit')
      this.$emit('select-prodaggreg', {
        item: dataItem
      })
      this.$emit('select-item', {
        item: dataItem
      })
    }
  }
}
</script>
